<template lang="pug">
    .borderNav--item.borderNav--sound.is-disabled(v-audioHover="", @click="audioToggle()")
        span.borderNav--item-text
            | Sound
            i.indicator(:style="{width: `${ volume }%`}", v-if="audio.clicked")
        ul
            li 
            li 
            li 
            li 
            li 
</template>
<script>
// import variables from '@/variables.js'
export default {
    data() {
        return {
            audio: null,
            working: false,
            audioEl: null,
            volume: 100
        }
    },
    created() {
        this.audio = this.$store.state.audio
    },
    mounted() {
        let self = this
        self.audioEl = document.querySelector('.borderNav--sound')

        self.audioToggle()

        self.audio.file.addEventListener('play', () => {
            self.audio.paused = false
            self.audio.clicked = false
        })
        self.audio.file.addEventListener('pause', () => {
            self.audio.paused = true
            if (!self.audio.clicked) {
                self.audioToggle()
            }
        })
    },
    methods: {
        audioToggle() {
            let self = this
            if (!self.working) {
                if (self.audio.file.paused) {
                    self.audio.file.volume = 0.0
                    self.audio.file.play()
                    self.audio.clicked = false
                    self.audioFadeIn()
                } else {
                    self.audio.clicked = true
                    self.audioFadeOut()
                }
            }
        },
        audioFadeIn() {
            let self = this
            self.working = true
            self.volume = ( 1 - self.audio.file.volume ) * 100
            if (!self.audio.file.paused) {
                self.audioEl.classList.remove('is-disabled')
                self.$store.state.audio.mobile = false
            } else {
                self.$store.state.audio.mobile = true
            }
            if (self.audio.file.volume < 1){
                self.audio.file.volume = Math.round((self.audio.file.volume + 0.05) * 100) / 100
                setTimeout(self.audioFadeIn, 100);
            } else {
                self.working = false
            }
        },
        audioFadeOut() {
            let self = this
            self.working = true
            self.audioEl.classList.add('is-disabled')
            self.volume = ( 1 - self.audio.file.volume ) * 100
            if (self.audio.file.volume > 0) {
                self.audio.file.volume = Math.round((self.audio.file.volume - 0.05) * 100) / 100
                setTimeout(self.audioFadeOut, 100);
            } else {
                self.audio.file.pause()
                self.working = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/audio.vue